module.exports = __webpack_public_path__ + "img/jon_TF_wordcloud.508eddcd.png";